import { Component, ElementRef, Input, Output, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { StateService, Transition } from '@uirouter/angular';
import { LogService } from '../../services/log.service';


@Component({
  selector: 'app-verify-product',
  templateUrl: './verify-product.component.html',
  styleUrls: ['./verify-product.component.scss']
})
export class VerifyProductComponent implements OnInit {

  @ViewChild("infoPanel") infoPanel;

  loading = false;
  productForm = {};
  user_id = { 'user_id': this.dataService.userDetails['user_id'] };
  productArray = [];
  currentEan = '';
  urlEan = '';

  constructor(
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private stateService: StateService,
    private modalService: NgbModal,
    private transition: Transition,
    private logService: LogService
  ) { }

  ngOnInit() {

    if (this.dataService.ean !== '') {
      this.productForm['ean'] = this.dataService.ean;
      this.typeProductEan();
      this.dataService.ean = '';
    }
    // this.logService.printLog("validation ean", this.dataService.ean)
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  typeProductEan() {
    this.productForm['user_id'] = this.dataService.userDetails['user_id'];
    this.currentEan = this.productForm['ean'];
    this.loading = true;
    this.apiService.typeBarCode(this.productForm, (response) => {
      // this.logService.printLog("product form response -", this.productForm);
      // this.logService.printLog("verify product response-", response);
      response.ean = this.currentEan;
      this.productArray.unshift(response);
      // this.logService.printLog("product Form -", this.productArray);
      this.loading = false;
      this.productForm["ean"] = "";
      this.infoPanel.getProductData();
      this.infoPanel.isProduct = true;
    });
  }

  codeDetected(event) {
    this.logService.printLog('scan code', event);
    this.productForm['ean'] = event.toUpperCase();
    this.typeProductEan();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/verify-product/verify-product.component.ts